export default __webpack_public_path__ + "static/starbook-8457b80efe409a624fbd5b5a80368cee.png";